// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left',
//       suggestionMobileStyle: 'style2',
      
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  
//     SearchInput.prototype.afterRender = function() {
// 		this.$element.removeAttr('type');
//     }
    
    var openSuggestionMobile = SearchInput.prototype.onOpenAutocomplete;
  	var closeSuggestionMobile = SearchInput.prototype.onCloseAutocomplete;
  
    if (Utils.isMobile()) {
        jQ('.site-nav .site-nav__link').on('click touchstart', function(e) {
			jQ('.site-header__search-form').addClass('is-active');
        });
      
      	jQ('.site-header__search .icon, .site-header__search-btn--cancel').on('click touchstart', function(e) {
          	jQ('.site-header__search-container').removeClass('is-active');
			jQ('.site-header__search-form').removeClass('is-active');
        });

        InstantSearchMobile.prototype.afterCloseInstantSearchMobile = function(isClose) {
			jQ('.site-header__search-container').removeClass('is-active');
			jQ('.site-header__search-form').removeClass('is-active');
        }
//         SearchInput.prototype.onOpenAutocomplete = function(event, autocompleteUi) {
//             openSuggestionMobile.call(this, event, autocompleteUi);

//             jQ('body').addClass('boost-pfs-search-suggestion-mobile-open');
//         }
//         SearchInput.prototype.onCloseAutocomplete = function(event, autocompleteUi) {
//             closeSuggestionMobile.call(this, event, autocompleteUi);

//             jQ('body').removeClass('boost-pfs-search-suggestion-mobile-open');
//         }
      
    } else {
        SearchInput.prototype._onFocusSearchBox  = function(event) {
			jQ('.site-header__search-form').addClass('is-active');
          	jQ('input[name="q"]').off('enableCloseListeners', 'focus');
        }
        jQ('.site-header__search-btn--cancel').on('click touchstart', function(e) {
          	jQ('.site-header__search-container').removeClass('is-active');
			jQ('.site-header__search-form').removeClass('is-active');
        });
    }
  
  
})();